// src/lib/lead/newLead.ts
import type { Lead } from "../../types/lead"; // adjust

export function createNewLead(opts?: {
  originLocationId?: string | null;
  originLocationName?: string | null;
}): Lead {
  const now = Date.now();
  return {
    id: crypto.randomUUID(),
    name: "New Customer",
    transcript: "",
    extracted: null,
    sent: false,
    lastUpdated: now,
    queued: false,
    sendError: null,
    lockedFields: {},
    origin_location_id: opts?.originLocationId ?? null,
    origin_location_name: opts?.originLocationName ?? null,
    needs_review: true,
    follow_ups: [],
  };
}